module.exports = __webpack_public_path__ + "img/1577035566.8aed2950.jpg";